import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import {
  AssigneeTypeEnum,
  RequestStepResultEnum,
  RequestStepStateEnum,
  RequestStepTaskTypeEnum,
} from '@omnea-app/packages/universal/hasura/graphql'

extendZodWithOpenApi(z)

export const AssigneeSchema = z
  .object({
    id: z.string(),
    value: z.string(),
    name: z.string().optional(),
    email: z.string().optional(),
    type: z.nativeEnum(AssigneeTypeEnum),
  })
  .openapi('Assignee')

export type AssigneeEntity = z.infer<typeof AssigneeSchema>

export const FormAssigneeSchema = z
  .object({
    type: z.enum(['primary_supplier_contact', 'user', 'someone_else']).optional(),
    email: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    jobTitle: z.string().optional().nullable(),
    assigneeType: z.nativeEnum(AssigneeTypeEnum).optional(),
    id: z.string().optional(),
    value: z.string().optional(),
  })
  .openapi('FormAssignee')

export const RequestStepDbSchema = z.object({
  id: z.string(),
  canvas_model_parent_ids: z.array(z.string()),
  input: z.object({
    id: z.string(),
    metadata: z.any(),
    inputNodes: z.array(z.string()),
    outputNodes: z.array(z.string()),
  }),
  state: z.nativeEnum(RequestStepStateEnum),
  workflow_id: z.string(),
  data: z.object({}).passthrough().optional().nullable(),
  request_id: z.string(),
  canvas_model_id: z.string(),
  result: z.nativeEnum(RequestStepResultEnum).nullable().optional(),
  action_taken_at: z.string().nullable(),
})

export const RequestStepTaskSchema = z.object({
  id: z.string(),
  request_step_id: z.string(),
  request_form_id: z.string().optional().nullable(),
  type: z.nativeEnum(RequestStepTaskTypeEnum),
  completed_on: z.string().optional().nullable(),
  completed_by: z.string().optional().nullable(),
  organisation_id: z.string(),
  created_at: z.string(),
  config: z.any(),
})
